import CircularProgress from '@mui/joy/CircularProgress'

export const LazyFallback = () => (
    <div className="flex items-center justify-center w-full h-full min-h-[200px]">
        <CircularProgress size="md" />
    </div>
)
